import { IIconProps } from '~/types';

const UpgradeIcon = ({ stroke = '#141414', size = 20, ...props }: IIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 14 14" {...props}>
    <path
      fill="none"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m13.5 4-3 3L7 2 3.5 7l-3-3v6.5A1.5 1.5 0 0 0 2 12h10a1.5 1.5 0 0 0 1.5-1.5z"
    />
  </svg>
);

export default UpgradeIcon;
